import { ChangeDetectionStrategy, Component, InputSignal, input } from '@angular/core';
import { Table } from 'primeng/table';
import { I18nService } from '../../../../../@core/services/i18n/i18n.service';
import { ColumnConfigEx, ColumnDefinitionEx } from '../../../../../@core/types/column-config-types-extended';
import { Condition, Operator, ProductToStoragePlaceLink, SearchInput, StoragePlace } from '../../../../../generated/generated-types';
import { BaseListWrapperComponent } from '../../../../../shared/components/base-list-wrapper/base-list-wrapper.component';
import { NewBaseListComponent } from '../../../../../shared/components/new-base-list-component/new-base-list-component';
import { StoragePlaceDropdownComponent } from '../../../../warehouse/controls/storage-place-dropdown/storage-place-dropdown.component';
import { ProductToStoragePlaceLinkService } from '../../../services/product-to-storage-place-link.service';

@Component({
  selector: 'app-product-to-storage-place-list-widget',
  template: `<app-base-list-wrapper [baseListComponent]="this" />`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    BaseListWrapperComponent
  ]
})
export class ProductToStoragePlaceListWidgetComponent extends NewBaseListComponent<ProductToStoragePlaceLink> {

  productIdInputSig: InputSignal<string> = input<string>();

  constructor(
    private service: ProductToStoragePlaceLinkService,
    private i18nService: I18nService) {
    super("ProductToStoragePlaceLink", service);
    this.inlineEditMode = true;
    this.addInDetail = false;
    this.addInDialog = false;
  }

  override getSearchInputForQuery(): SearchInput {
    let si = super.getSearchInputForQuery();
    if (this.productIdInputSig())
      this.service.applySearchRule(si, {
        field: 'productId',
        value: this.productIdInputSig(),
        operator: Operator.equal,
        condition: Condition.AND
      });
    return si;
  }

  async saveInCRUDService(rowData: ProductToStoragePlaceLink): Promise<ProductToStoragePlaceLink> {
    rowData.productId = this.productIdInputSig();
    return await super.saveInCRUDService(rowData);
  }

  async refresh(): Promise<void> {
    // this is a workaround but this component should anyways only be loaded if connected product is set
    if (this.productIdInputSig())
      await super.refresh();
  }

  protected async setColumnConfig(colConfig: ColumnConfigEx, table?: Table) {

    for (let cd of colConfig.columns) {
      // it has to be product identifier to get the dropdown for choosing the product
      if (cd.field == "storagePlace.identifier") {
        cd.getEditComponent = () => StoragePlaceDropdownComponent;
        cd.editComponentCreated = async (c: StoragePlaceDropdownComponent, rowData: ProductToStoragePlaceLink, colDef: ColumnDefinitionEx) => {

          if (rowData?.storagePlace)
            c.setModel(rowData.storagePlace);
          else if (rowData?.storagePlaceId) {
            await c.loadItemByIdAndSetSelected(rowData.storagePlaceId);
            this.cdRef.detectChanges();
          }
          c?.value?.subscribe(async x => {

            rowData.storagePlace = x as StoragePlace;

            if (rowData == null) {
              rowData = {} as ProductToStoragePlaceLink;
            }
          })
        }
      }
    }
    super.setColumnConfig(colConfig);
  }
}
